import { sample } from 'effector';
import {
  calculateDistThresholdsEv,
  calculateHexThresholdsEv,
  calculateThresholdsEv,
  putBlockedBucketsEv,
  putThresholdsEv,
  resetBlockedBucketsEv,
} from './events.js';
import {
  $blockedBuckets,
  $gradientBuckets,
  $gradientBucketsDist,
  $gradientBucketsHexagons,
} from './stores.js';
import { $activeFilters } from '../activeFiltersModel/index.js';
import { bucketsByAlgorithmFx } from './effects.js';
import { getLessColors } from '../../utils/gradient-utils.js';
import { gradient_colors } from '../../dictionaries/gradient_dictionary.js';
import { $hexProperty, $regionsLayer } from '../investProModel/index.js';

$blockedBuckets.reset(resetBlockedBucketsEv);

sample({
  source: $blockedBuckets,
  clock: putBlockedBucketsEv,
  fn: (source, clock) => {
    return {
      ...source,
      [clock.zoom]: clock.value,
    };
  },
  target: $blockedBuckets,
});

sample({
  source: [$activeFilters, $regionsLayer],
  clock: calculateThresholdsEv,
  // filter: (activeFilters) => activeFilters.gradient.length === 0,
  fn: ([activeFilters, regionsLayer], clock) => {
    return {
      hexagons:
        regionsLayer === 'unemployment_rate'
          ? clock.map((item) => {
              return {
                ...item,
                properties: {
                  ...item.properties,
                  index_main: item.properties.index_main * 10,
                },
              };
            })
          : clock,
      algorithm: 'JNK',
      to: 'regions',
    };
  },
  target: bucketsByAlgorithmFx,
});

sample({
  source: [$activeFilters, $regionsLayer],
  clock: calculateDistThresholdsEv,
  // filter: (activeFilters) => activeFilters.gradient.length === 0,
  fn: ([activeFilters, regionsLayer], clock) => {
    return {
      hexagons:
        regionsLayer === 'unemployment_rate'
          ? clock.map((item) => {
              return {
                ...item,
                properties: {
                  ...item.properties,
                  index_main: item.properties.index_main * 10,
                },
              };
            })
          : clock,
      algorithm: 'JNK',
      to: 'districts',
    };
  },
  target: bucketsByAlgorithmFx,
});

sample({
  clock: calculateHexThresholdsEv,
  fn: (clock) => {
    return {
      hexagons: clock,
      algorithm: 'JNK',
      to: 'hexagons',
    };
  },
  target: bucketsByAlgorithmFx,
});

sample({
  source: [$gradientBuckets, $regionsLayer],
  clock: putThresholdsEv,
  filter: (_, clock) => clock.to === 'regions',
  fn: ([gradientBuckets, regionsLayer], clock) => {
    const { buckets } = clock;
    // let { colors } = gradientBuckets;
    // if (clock.length - 1 < 10) {
    //   colors = getLessColors(clock.length - 1);
    // } else {
    const colors = gradient_colors.invest_pro;
    // }

    return {
      buckets:
        regionsLayer === 'unemployment_rate'
          ? buckets.map((item) => item / 10)
          : buckets,
      colors,
    };
  },
  target: $gradientBuckets,
});

sample({
  source: [$gradientBuckets, $regionsLayer],
  clock: putThresholdsEv,
  filter: (_, clock) => clock.to === 'districts',
  fn: ([gradientBuckets, regionsLayer], clock) => {
    const { buckets } = clock;
    // let { colors } = gradientBuckets;
    // if (clock.length - 1 < 10) {
    //   colors = getLessColors(clock.length - 1);
    // } else {
    const colors = gradient_colors.invest_pro;
    // }

    return {
      buckets:
        regionsLayer === 'unemployment_rate'
          ? buckets.map((item) => item / 10)
          : buckets,
      colors,
    };
  },
  target: $gradientBucketsDist,
});

sample({
  source: [$gradientBucketsHexagons, $hexProperty],
  clock: putThresholdsEv,
  filter: (_, clock) => clock.to === 'hexagons',
  fn: ([gradientBuckets, hexProperty], clock) => {
    let { buckets } = clock;
    let colors;
    if (clock.length - 1 < 10) {
      colors = getLessColors(clock.length - 1);
    } else {
      colors = gradient_colors.dark;
    }

    if (hexProperty === 'hhi') {
      buckets = [...buckets].reverse();
      colors = [...colors].reverse();
    }

    return {
      buckets,
      colors,
    };
  },

  target: $gradientBucketsHexagons,
});

sample({
  clock: bucketsByAlgorithmFx.doneData,
  target: putThresholdsEv,
});
